import React, { useEffect, useState } from "react";
import DeletePops from "../../../Pops/DeletePops";
import { useDispatch } from "react-redux";
import { Helper } from "../../../../tools/Helper";
import { api_Routes } from "../../../../tools/api_Routes";
import {
  LinearProgress,
  Pagination,
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell, TablePagination,
} from "@mui/material";
import { AddButton } from "../../../Button/AddButton";
import { setOpen } from "../../../../Redux/ModalReducer";
import DeleteModal from "../DeleteModal";
import DataTable from "../data-table";
import { Can } from "../../../Can";

const TelegramGroupTable = () => {
  const [TelegramGroups, setTelegramGroups] = useState([]);
  const [loading, setIsLoading] = useState(true);
  const [keyword, setKeyword] = useState("");
  const [debouncedKeyword, setDebouncedKeyword] = useState("");
  const [show, setShow] = useState(false);
  const [selectedId, setSelectedId] = useState(false);
  const [shouldRefresh, setShouldRefresh] = useState(false);

  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [sortConfig, setSortConfig] = useState({
    field: 'order',
    direction: 'asc',
  });

  const dispatch = useDispatch();
  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  const handleKeywordChange = (event) => {
    setKeyword(event.target.value);
  };

  const handleSortRequest = (field) => {
    let direction = "asc";
    if (sortConfig.field === field && sortConfig.direction === "asc") {
      direction = "desc";
    }
    setSortConfig({ field, direction });
    setCurrentPage(1);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedKeyword(keyword);
      setCurrentPage(1);
    }, 300);
    return () => {
      clearTimeout(handler);
    };
  }, [keyword]);

  useEffect(() => {
    if (shouldRefresh) {
      setCurrentPage(1);
      setShouldRefresh(false);
    }
  }, [shouldRefresh]);

  useEffect(() => {
    setIsLoading(true);
    setTelegramGroups([]);
    get_Telegram_Groups();
  }, [currentPage, debouncedKeyword, sortConfig]);

  const get_Telegram_Groups = async () => {
    const { response } = await Helper.Get({
      url: `${api_Routes.Groups.Telegram.View}?per_page=${rowsPerPage}&page=${currentPage}&keyword=${keyword}&sortField=${sortConfig.field}&sortDirection=${sortConfig.direction}`,
      hasToken: true,
    });
    if (response) {
      setTelegramGroups(response);
    }
    setIsLoading(false);
  };

  const handleClose = () => {
    setShow(false);
    dispatch(setOpen(false));
  };

  const handleShow = () => {
    setShow(true);
    dispatch(setOpen(true));
  };

  const handleRowReorder = async (draggedId, targetId) => {
    // Create a new array with the reordered items
    const newData = [...TelegramGroups.data];
    const draggedIndex = newData.findIndex(item => item.id === draggedId);
    const targetIndex = newData.findIndex(item => item.id === targetId);

    if (draggedIndex === -1 || targetIndex === -1) return;

    // Remove the dragged item from its current position
    const [movedItem] = newData.splice(draggedIndex, 1);

    // Insert it at the target position (displacement)
    newData.splice(targetIndex, 0, movedItem);

    // Update local state immediately
    setTelegramGroups(prev => ({
      ...prev,
      data: newData
    }));

    // Calculate new order values for all affected items
    const orderUpdates = newData.map((item, index) => ({
      id: item.id,
      order: index + 1 + ((currentPage - 1) * rowsPerPage)  // Assuming order starts at 1
    }));

    // Send bulk update to server
    try {
      await Helper.Post({
        url: api_Routes.Groups.Telegram.Reorder,
        hasToken: true,
        data: { updates: orderUpdates }
      });
    } catch (error) {
      console.error("Reorder failed:", error);
      // Revert if server update fails
      setShouldRefresh(true);
    }
  };

  return (
      <div>
        <div className="flex flex-col-reverse justify-between items-center gap-4 mb-3 md:flex-row">
          <label className="font-bold inline-block text-textColor dark:text-darkTextColor text-[15px]  text-start">
            Search :
            <input
                placeholder="Write any keyword"
                type="text"
                name="keyword"
                value={keyword}
                onChange={handleKeywordChange}
                autoComplete="off"
                className="duration-200 font-normal bg-secondary dark:bg-darkPrimary text-textColor dark:text-darkTextColor ml-2
                           border-2 input-box
                           rounded-[0.25rem]  py-1 px-3 outline-none"
            />
          </label>
          <Can I="store" a="telegramGroups">
            <AddButton to="/AddTelegramGroups" label="Add Telegram Group" />
          </Can>
        </div>
        <DeletePops />
        {loading ? (
            <LinearProgress sx={{ marginTop: 1 }} />
        ) : TelegramGroups?.data?.length > 0 ? (
            <>
              <DeleteModal
                  show={show}
                  handleClose={handleClose}
                  selectedId={selectedId}
                  setShouldRefresh={setShouldRefresh}
              />
              <div className="overflow-x-auto">
                <DataTable
                    data={TelegramGroups?.data}
                    setSelectedId={setSelectedId}
                    handleShow={handleShow}
                    onSort={handleSortRequest}
                    sortConfig={sortConfig}
                    onRowReorder={handleRowReorder}
                />
              </div>
              <div className="mt-4 flex justify-center items-center">
                <TablePagination
                    page={currentPage}
                    className="mt-auto"
                    onPageChange={handlePageChange}
                    count={TelegramGroups.pagination.total}
                    rowsPerPage={rowsPerPage}
                    onRowsPerPageChange={handleChangeRowsPerPage}
                    variant="outlined"
                    shape="rounded"
                    rowsPerPageOptions={[5, 10, 25, 50]}
                />
                {/*<Pagination*/}
                {/*    page={currentPage}*/}
                {/*    className="mt-auto"*/}
                {/*    onChange={handlePageChange}*/}
                {/*    count={TelegramGroups.pagination.total_pages}*/}
                {/*    variant="outlined"*/}
                {/*    shape="rounded"*/}
                {/*/>*/}
              </div>
            </>
        ) : (
            <TableContainer>
              <Table aria-label="collapsible table">
                <TableHead>
                  <TableRow>
                    <TableCell
                        align="center"
                        sx={{
                          backgroundColor: "primary.main",
                          color: "white",
                          fontWeight: "bold",
                        }}
                    >
                      There are no data yet
                    </TableCell>
                  </TableRow>
                </TableHead>
              </Table>
            </TableContainer>
        )}
      </div>
  );
};

export default TelegramGroupTable;